import { useSearchParams } from 'react-router-dom';
import './TrackersBuldRedirect.scss';
import { useEffect, useState } from 'react';
import EndPoint from '../services/endpoint';
import { Tracker } from '../types';
import TrackersBulkRedirection from '../components/TrackersBulkRedirection';
import Loader from '../components/Loader';

function ParamsError() {
    return (
        <div className="params-errors">
            Has errors on params.<br />
            Please go back and retry your navigation.
        </div>
    );
}

export default function TrackersBulkRedirect () {

    const [searchParams] = useSearchParams();

    const [loaded, setLoaded] = useState(false);
    const [hasParamsError, setHasParamsError] = useState(false);
    const [trackers, setTrackers] = useState<Tracker[]>([]);

    const ids = searchParams.get('ids')

    useEffect(() => {
        Promise.resolve()
            .then(() => setLoaded(false))
            .then(() => setHasParamsError(false))
            .then(() => ids ? ids : Promise.reject())
            .then(list => list.split(','))
            .then(list => list.map(id => Number(id)))
            .then(list => list.map(id => EndPoint.tracker(id)))
            .then(list => Promise.all(list))
            .then(list => {
                setLoaded(true);
                setHasParamsError(false);
                setTrackers(list)
            }).catch(() => {
                setLoaded(true);
                setHasParamsError(true);
                setTrackers([])
                return;
            })
    }, [ids])

    return (
        <div className="trackers-bulk-redirect-page">
            <h1 className="page-title">Redirection multi-trackers</h1>
            {   !loaded ? <Loader />
                : hasParamsError ? <ParamsError />
                : <TrackersBulkRedirection trackers={trackers} />
            }
        </div>
    );
};
